import { useState, useEffect } from "react";
import { themes } from "../themes/Themes";

export default function useCurrentTheme() {
  const [theme, setTheme] = useState("lime"),
    setMode = (mode) => {
      window.localStorage.setItem("theme", mode);
      setTheme(mode);
    },
    themeToggler = (themeId) => {
      setMode(themes.find((theme) => theme.id === themeId).name);
    };
  useEffect(() => {
    const currentTheme = window.localStorage.getItem("theme");
    currentTheme && setTheme(currentTheme);
  }, []);
  return [theme, themeToggler];
}
